module.exports = "pegasus/assets/blocks/column-5-theme2.png";